export enum AnalyticsPages {
  LOGIN = 'login',
}

export const AnalyticsPlaces = {
  LOGIN: {
    PAGE: 'LoginPage',
  },
}
